import { Container, ImageCheck } from './styles';
import checkMark from '../../../assets/image/white-cekcmark.png';

interface CheckboxProps {
  id: string;
  isSelected?: boolean;
  onChange: (checked: boolean) => void;
}

const Checkbox = ({ id, isSelected = false, onChange }: CheckboxProps) => {
  return (
    <Container id={id} isSelected={isSelected} onClick={() => onChange(!isSelected)}>
      {isSelected && <ImageCheck src={checkMark} />}
    </Container>
  );
};

export default Checkbox;